import { render, staticRenderFns } from "./SignUpForm.vue?vue&type=template&id=0b985d3a&"
import script from "./SignUpForm.vue?vue&type=script&lang=ts&"
export * from "./SignUpForm.vue?vue&type=script&lang=ts&"
import style0 from "./SignUpForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports